function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m266.199 300.876c18.872 17.697 54.49 37.24 96.86 37.24 65.648 0 113.604-48.665 113.607-48.668v-190.733c0-4.141-4.625-6.599-8.052-4.274-16.285 11.045-55.849 33.785-105.554 33.785-21.551 0-41.195-4.275-57.862-10.018l-50.891 173.295z",
  fill: "#f1cb66"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.06 329.116c-42.37 0-77.366-16.522-96.86-28.24l-10.2-2.985-6.547 10.138s47.958 39.668 113.607 39.668c57.733 0 101.784-30.678 111.568-38.077 1.289-.974 2.039-2.494 2.039-4.11v-16.062c-.001 0-47.958 39.668-113.607 39.668z",
  fill: "#ebb059"
}), /*#__PURE__*/React.createElement("path", {
  d: "m249.453 273.149v34.88l38.998-16.658c-3.913-10.176-20.348-21.318-38.998-18.222z",
  fill: "#9d7d52"
}), /*#__PURE__*/React.createElement("path", {
  d: "m305.197 284.219s-21.639-17.899-55.744-29.65v18.581c16.101 5.548 29.419 12.464 38.998 18.222z",
  fill: "#8a6d49"
}), /*#__PURE__*/React.createElement("path", {
  d: "m191.591 237.469c65.649 0 113.607 28.169 113.607 28.169v-203.658s-47.957-39.668-113.607-39.668c-65.649 0-113.607 39.668-113.607 39.668l-9 95.152 9 108.506c.003-.002 47.959-28.169 113.607-28.169z",
  fill: "#f7e471"
}), /*#__PURE__*/React.createElement("path", {
  d: "m77.984 265.638-9 7.332 9 11.249s47.958-39.668 113.607-39.668 113.607 39.668 113.607 39.668v-18.581s-47.957-39.668-113.607-39.668c-65.649 0-113.607 39.668-113.607 39.668z",
  fill: "#f1cb66"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45.656 502.419h22.005c5.701 0 10.323-7.764 10.323-19.323v-461.771c0-11.777-9.547-21.325-21.325-21.325s-21.325 9.548-21.325 21.325v461.772c0 14.451 4.621 19.322 10.322 19.322z",
  fill: "#9d7d52"
}), /*#__PURE__*/React.createElement("path", {
  d: "m67.661 493.419h-22.005c-5.701 0-10.323-4.622-10.323-10.323v18.581c0 5.701 4.622 10.323 10.323 10.323h22.005c5.701 0 10.323-4.622 10.323-10.323v-18.581c0 5.702-4.621 10.323-10.323 10.323z",
  fill: "#8a6d49"
})));

const SvgFlag = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  enableBackground: "new 0 0 512 512",
  height: 512,
  viewBox: "0 0 512 512",
  width: 512,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Flag.5111b463.svg";
export { ForwardRef as ReactComponent };